/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillLevelDropdown_company = {
    readonly skillLevels: ReadonlyArray<{
        readonly id: string;
        readonly level: number | null;
        readonly description: string | null;
    } | null> | null;
    readonly " $refType": "SkillLevelDropdown_company";
};
export type SkillLevelDropdown_company$data = SkillLevelDropdown_company;
export type SkillLevelDropdown_company$key = {
    readonly " $data"?: SkillLevelDropdown_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillLevelDropdown_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelDropdown_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillLevel",
      "kind": "LinkedField",
      "name": "skillLevels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "level",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'cb98250d357f9d3e31120740082b39a0';
export default node;
